<template>
  <main-layout
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">
    <div class="container">
      <grid-row column-align="center">
        <grid-col col-size="4">
          <h1 class="header margin-top-xl">
            <chevron
              @click="$router.push({name: 'UserList'})"/>
            {{ isEdition() ? $t('user.editFormTitle') : $t('user.addFormTitle') }}
          </h1>
          <alert
            v-if="alertVisible"
            :message="alertMessage"
            :type="alertType">
          </alert>
        </grid-col>
      </grid-row>
      <form
        v-on:submit.prevent
        v-on:keypress.enter.prevent="onSave"
        v-on:keydown.space.prevent="'false'">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field variable-input-field-name">
              <label-input
                :lowercase="true"
                :disabled="isEdition()"
                ref="nameInput"
                form-size="m"
                :label="$t('user.nameLabel')"
                v-model="name"
                :type="'text'"
                :error="nameErrorLenght || nameErrorUnique"
                :errorMessage="displayNameErrorMessage">
              </label-input>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center" col-spaced>
          <grid-col col-size="2">
            <div class="variable-input-field variable-input-field-name">
              <label-input
                ref="passwordInput"
                form-size="m"
                :label="$t('user.password')"
                v-on:click="onClickPassword"
                v-model="password"
                :type="'password'"
                :error="passwordError"
                :errorMessage="$t('user.passwordFormatMessage')"
                autocomplete="new-password">
              </label-input>
            </div>
          </grid-col>
          <grid-col col-size="2">
            <div class="variable-input-field variable-input-field-name">
              <label-input
                ref="passwordRepeatInput"
                form-size="m"
                :label="$t('user.passwordRepeat')"
                v-on:click="onClickPassword"
                v-model="passwordRepeat"
                :type="'password'"
                :error="passwordRepeatError"
                :errorMessage="$t('user.passwordShouldBeEqual')"
                autocomplete="new-password">
              </label-input>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field submit-buttons align-right margin-bottom-xxl">
              <checkbox
                id="admin-enabled"
                :label="$t('user.admin')"
                v-on:change="onAdminChnage"
                :checked="admin">
              </checkbox>
            </div>
          </grid-col>
        </grid-row>
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="variable-input-field submit-buttons align-right">
              <btn-pill
                :btnText="$t('commons.cancel')"
                v-on:click="onCancel"
                btn-size="m"
                btn-type="secondary">
              </btn-pill>
              <btn-pill
                :btnText="$t('commons.save')"
                v-on:click="onSave"
                btn-size="m">
              </btn-pill>
            </div>
          </grid-col>
        </grid-row>
      </form>
    </div>
  </main-layout>
</template>

<script>
import {mapActions} from 'vuex';
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import LabelInput from '@/components/shared/forms/LabelInput';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import Radio from '@/components/shared/forms/Radio';
import ToggleSwitch from '@/components/shared/forms/ToggleSwitch';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Checkbox from '@/components/shared/forms/Checkbox';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';

export default {
  components: {
    MainLayout,
    GridRow,
    GridCol,
    LabelInput,
    LabelSelect,
    Radio,
    ToggleSwitch,
    BtnPill,
    Checkbox,
    Alert,
    Chevron
  },
  data () {
    return {
      user: {},
      name: '',
      password: '',
      passwordRepeat: '',
      admin: false,
      /* Form field errors */
      nameErrorLenght: false,
      nameErrorUnique: false,
      passwordError: false,
      passwordRepeatError: false,
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '' // error, warning, success
    };
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.settings'),
          link: '/settings'
        },
        {
          name: this.$t('user.title'),
          link: '/user/list'
        },
        {
          name: this.isEdition() ? this.$t('user.editFormTitle') : this.$t('user.addFormTitle'),
          link: '/user',
          disabled: true
        }
      ];
    },
    displayNameErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.nameErrorUnique) {
        errorMessage = this.$t('user.userAlreadyExists');
      }
      return errorMessage;
    }
  },
  created () {
    this.user = this.$route.params;
    if (this.isEdition()) {
      this.name = this.user.name;
      this.admin = this.user.admin;
      this.password = PASSWORD_DEFAULT_VALUE;
      this.passwordRepeat = PASSWORD_DEFAULT_VALUE;
    }
  },
  mounted () {
    this.$refs.nameInput.focus();
  },
  methods: {
    ...mapActions([
      'createUser',
      'updateUser'
    ]),
    isEdition () {
      return this.user.id !== undefined;
    },
    onSave () {
      clearErrors(this);
      if (isValidForm(this)) {
        this.user.name = this.name.toLowerCase();
        this.user.admin = this.admin;
        this.user.password = this.password !== PASSWORD_DEFAULT_VALUE ? this.password : undefined;

        if (this.isEdition()) {
          updateUser(this, this.user);
        } else {
          createUser(this, this.user);
        }
      }
    },
    onCancel () {
      this.$router.push({name: 'UserList'});
    },
    onAdminChnage (value) {
      this.admin = value;
    },
    onClickPassword () {
      if (this.password === PASSWORD_DEFAULT_VALUE) {
        this.password = '';
        this.passwordRepeat = '';
      }
    }
  }
};

const PASSWORD_DEFAULT_VALUE = 'passw0rd';

const clearErrors = (context) => {
  context.nameErrorLenght = false;
  context.nameErrorUnique = false;
  context.passwordError = false;
  context.passwordRepeatError = false;
};

const isValidForm = (context) => {
  let valid = true;
  if (!(context.name && context.name.length > 0)) {
    valid = false;
    context.nameErrorLenght = true;
  }

  if (!(context.password && isValidPassword(context))) {
    valid = false;
    context.passwordError = true;
  }
  if (!(context.password === context.passwordRepeat)) {
    valid = false;
    context.passwordRepeatError = true;
  }
  return valid;
};

const isValidPassword = (context) => {
  const containsLetters = /[a-z]+/i.test(context.password);
  const containsNumbers = /\d/.test(context.password);
  const passwordLength = context.password.length >= 6;
  return (containsLetters === true && containsNumbers === true && passwordLength === true);
};

const createUser = (context, user) => {
  context.createUser({context: context, user}).then(() => {
    const msg = context.$t('user.successCreation', {name: user.name});
    context.$router.replace({ name: 'UserList', params: {alert: msg} });
  }).catch((error) => {
    if (error.status === 409) {
      context.nameErrorUnique = true;
    } else if (error.status === 428) {
      context.passwordError = true;
    } else {
      showAlert(context, context.$t('user.errorCreation'), 'error');
    }
  });
};

const updateUser = (context, user) => {
  const msg = context.$t('user.successUpdate', {name: user.name});
  context.updateUser({context: context, user}).then(() => {
    context.$router.replace({ name: 'UserList', params: {alert: msg} });
  }).catch(() => {
    showAlert(context, context.$t('user.errorUpdate', {name: user.name}), 'error');
  });
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};

</script>

<style lang="scss" scoped>
  @import "src/stylesheets/variables";

  .variable-input-field {
    display: inline-block;
  }

  .variable-input-field-name {
    width: 100%;
    margin: 0 0;
  }

  .submit-buttons {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/user/User.vue